import React, { useCallback, useMemo } from "react";
import DataTable from "../_Components/DataTable";
import _ from "lodash";
import { Button } from "react-bootstrap";
import SplitNumber from "../_Components/SplitNumber";
import { Switch } from "@mui/material";
import ApiAgent from "../../../core/api/api.agent";
import SwalMessage from "../_Components/SwalMessage";

function DataGrid({
  data,
  setShowModalAgent,
  setSelectedAgent,
  setShowModalUserClaims,
  setSelectedUser,
  setShowModalEditUserName,
  setShowAddSupplierToAgentModal,
}) {
  const callApiService = useCallback(async (item) => {
    const response = await ApiAgent.updateAgentIsActive({
      id: item.id,
      isActive: !item.isActive,
    });
    if (response.succeeded == true) {
      document.getElementById("submitButton").click();
    }

    SwalMessage({ title: response.message, iSsuccess: response.succeeded });
  }, [])
  const columns = useMemo(() => [
    {
      accessor: "id",
      Header: "#",
      minWidth: 50,
    },
    {
      accessor: "companyName",
      Header: "نام شرکت    ",
      minWidth: "100px",
    },
    {
      Header: "مدیر عامل",
      minWidth: "100px",
      align: "center",
      Cell: ({ row }) => (
        <>
          <span className="mr-1 d-inline-block">
            {row.original.ceoFirstName === "null" || row.original.ceoFirstName === null
              ? " "
              : row.original.ceoFirstName}
          </span>
          <span className="d-inline-block">
            {row.original.ceoLastName === "null" || row.original.ceoLastName === null ? " " : row.original.ceoLastName}
          </span>
        </>
      ),
    },
    {
      accessor: "phoneNumber",
      Header: "شماره تماس",
      minWidth: "100px",
    },
    {
      accessor: "cityName",
      Header: "شهر",
      minWidth: "50px",
    },
    {
      accessor: "agentApprovalStatusS",
      Header: "وضعیت",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div
          className={`d-inline-block rounded-pill px-4 py-1 ${row.original.agentApprovalStatus === 4 ? "bg-light-danger text-danger" : row.original.agentApprovalStatus === 3 ? " bg-light-success text-success" : row.original.agentApprovalStatus === 2 || row.original.agentApprovalStatus === 1 ? " bg-light-primary text-primary" : ""}`}
        >
          {row.original.agentApprovalStatusS}
        </div>
      ),
    },
    {
      accessor: "riallBalance",
      Header: "موجودی کیف پول",
      minWidth: "100px",
      Cell: ({ row }) => (
        <div>
          <SplitNumber number={row.original.riallBalance} />
        </div>
      ),
    },
    {
      Header: "فعال",
      minWidth: "100px",
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Switch
            checked={row.original.isActive ? true : false}
            value={row.original.isActive}
            color="primary"
            inputProps={{ "aria-label": "primary checkbox" }}
            onChange={async () => { await callApiService(row.original) }}
          />
        </div>
      ),
    },
    {
      accessor: "createdPersianTime",
      Header: "زمان ایجاد",
      minWidth: 90,
      maxWidth: 90,
    },
    {
      Header: "عملیات",
      accessor: "",
      minWidth: 200,
      align: "center",
      Cell: ({ row }) => (
        <div className="text-center">
          <Button
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            title="ویرایش"
            onClick={() => {
              setSelectedAgent(row.original.id);
              setShowModalAgent(true);
            }}
          >
            <i className="far fa-edit text-small"></i>
          </Button>
          <Button
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            title="ویرایش نام کاربری"
            onClick={() => {
              setSelectedUser(row.original.id);
              setShowModalEditUserName(true);
            }}
          >
            <i className="far fa-user text-small"></i>
          </Button>
          {row.original.agentApprovalStatus == 3 && (
            <Button
              className="btn btn-light-success btn-sm mr-2 btn-icon"
              title="بررسی و تغییر وضعیت نماینده"
              onClick={() => {
                setSelectedAgent(row.original.id);
                setShowModalAgent(true);
              }}
            >
              <i className="far fa-check-circle text-small "></i>
            </Button>
          )}
          <Button
            className="btn btn-light-info btn-sm mr-2 btn-icon"
            title="ویرایش مجوزها"
            onClick={() => {
              setSelectedUser(row.original.id);
              setShowModalUserClaims(true);
            }}
          >
            <i className="fa fa-link text-small "></i>
          </Button>
          <Button
            className="btn btn-light-primary btn-sm mr-2 btn-icon"
            onClick={() => {
              setSelectedUser(row.original.id);
              setShowAddSupplierToAgentModal(true);
            }}
            title="اضافه کردن تامین کننده به نماینده"
          >
            <i className="fa fa-plus text-small "></i>
          </Button>
        </div>
      ),
    },
  ]);

  const config = {
    page_size: 10,
    length_menu: [10, 20, 50, 100],
    show_filter: false,
    show_pagination: true,
    pagination: "advance",
    button: {
      excel: false,
      print: false,
    },
    language: {
      length_menu: " _MENU_  رکورد در هر صفحه",
      filter: "جستجو ...",
      info: " _START_ - _END_ از _TOTAL_ رکورد",
      pagination: {
        first: "First",
        previous: <i className="fa fa-chevron-right"></i>,
        next: <i className="fa fa-chevron-left"></i>,
        last: "Last",
      },
    },
  };

  return (
    <div>
      <DataTable config={config} columns={columns} data={data} />
    </div>
  );
}

export default DataGrid;
